// Eine Entscheidung fürs Talent-UI in Multi-Lingual-Projekten (Spec
// 2026-09-21 § 6): `_simpleMode` heißt nur noch „Multi-Lingual-Talent"
// (kein SfxTrack, keine Custom-Assets). Ob ein Asset die flexible Timeline
// bekommt, hängt am Video: mit Video ist die Videodauer die Länge.
//
// Bestandsschutz: Standard-Projekte (`_simpleMode` fehlt) sind nie flex,
// bestehende Multi-Projekte haben kein `videoPath` — für die bleibt
// `isFlexAsset` auf jedem Asset `true`, also exakt das bisherige Verhalten.
export function isFlexAsset(
  config: { _simpleMode?: boolean } | null | undefined,
  asset: { videoPath?: string | null } | null | undefined,
): boolean {
  return config?._simpleMode === true && !asset?.videoPath;
}

export type HelpVariant = 'simple' | 'tts' | 'sts';

// Welchen Guide das Help-Overlay zeigt (Spec 2026-09-21 § 2): STS immer den
// STS-Guide, TTS ohne Video den reduzierten `simple`-Guide, TTS mit Video den
// vollen TTS-Guide. Die SFX-/Eigenvideo-Absätze blendet das Overlay in
// Multi-Lingual zusätzlich aus (`hideSfxAndCustom`).
export function helpVariant(
  config: { _simpleMode?: boolean } | null | undefined,
  asset: { videoPath?: string | null } | null | undefined,
  activeAssetType: 'tts' | 'sts',
): HelpVariant {
  if (activeAssetType === 'sts') return 'sts';
  return isFlexAsset(config, asset) ? 'simple' : 'tts';
}
